export default __webpack_public_path__ + "static/media/icon__14.a368dad0.svg";